import * as React from "react";
const SvgCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#A6ADB9"
      d="M15.75 2.25H15V.75a.75.75 0 0 0-.75-.75h-.75a.75.75 0 0 0-.75.75v1.5h-7.5V.75A.75.75 0 0 0 4.5 0h-.75A.75.75 0 0 0 3 .75v1.5h-.75C1.01 2.25 0 3.26 0 4.5v11.25C0 16.99 1.01 18 2.25 18h13.5c1.24 0 2.25-1.01 2.25-2.25V4.5c0-1.24-1.01-2.25-2.25-2.25m.75 13.5c0 .413-.337.75-.75.75H2.25a.75.75 0 0 1-.75-.75V7.53h15z"
    />
  </svg>
);
export default SvgCalendar;
